import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconViewOff';
/** Renders an SVG icon. */
const SvgViewOff = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M27.707 4.293a1 1 0 0 1 0 1.414l-8.26 8.261a4 4 0 0 1-5.478 5.478l-8.262 8.261a1 1 0 0 1-1.414-1.414l3.836-3.836a14 14 0 0 1-1.24-.95l-3.768-3.23a3 3 0 0 1 0-4.555l3.768-3.23a14 14 0 0 1 15.189-1.984l4.215-4.215a1 1 0 0 1 1.414 0m-7.143 5.729A12 12 0 0 0 8.191 12.01l-3.769 3.23a1 1 0 0 0 0 1.518l3.769 3.23q.663.568 1.382 1.024l2.98-2.981a4 4 0 0 1 5.478-5.478l2.533-2.532Zm-4.046 4.046a2 2 0 0 0-2.45 2.45zm-1.036 3.864A2.004 2.004 0 0 0 18 16q0-.27-.068-.518zm8.22-7.331a1 1 0 0 1 1.41-.109l3.767 3.23a3 3 0 0 1 0 4.556l-3.768 3.23a14 14 0 0 1-12.974 2.828 1 1 0 1 1 .551-1.922 12 12 0 0 0 11.122-2.425l3.768-3.23a1 1 0 0 0 0-1.518l-3.768-3.23a1 1 0 0 1-.109-1.41Z"
      />
    </svg>
  );
};
SvgViewOff.displayName = displayName;
export default SvgViewOff;
